// Base stats database for Pokemon Champions roster
// Used to give custom teams stats for damage calculations
// Format: { hp, atk, def, spa, spd, spe }
// Mega stats stored separately where applicable

const BASE_STATS = {
  'Venusaur':     { hp: 80, atk: 82, def: 83, spa: 100, spd: 100, spe: 80 },
  'Charizard':    { hp: 78, atk: 84, def: 78, spa: 109, spd: 85, spe: 100 },
  'Blastoise':    { hp: 79, atk: 83, def: 100, spa: 85, spd: 105, spe: 78 },
  'Beedrill':     { hp: 65, atk: 90, def: 40, spa: 45, spd: 80, spe: 75 },
  'Pidgeot':      { hp: 83, atk: 80, def: 75, spa: 70, spd: 70, spe: 101 },
  'Arbok':        { hp: 60, atk: 95, def: 69, spa: 65, spd: 79, spe: 80 },
  'Pikachu':      { hp: 35, atk: 55, def: 40, spa: 50, spd: 50, spe: 90 },
  'Raichu':       { hp: 60, atk: 90, def: 55, spa: 90, spd: 80, spe: 110 },
  'Clefable':     { hp: 95, atk: 70, def: 73, spa: 95, spd: 90, spe: 60 },
  'Ninetales':    { hp: 73, atk: 76, def: 75, spa: 81, spd: 100, spe: 100 },
  'Ninetales-Alola': { hp: 73, atk: 67, def: 75, spa: 81, spd: 100, spe: 109 },
  'Arcanine':     { hp: 90, atk: 110, def: 80, spa: 100, spd: 80, spe: 95 },
  'Alakazam':     { hp: 55, atk: 50, def: 45, spa: 135, spd: 95, spe: 120 },
  'Machamp':      { hp: 90, atk: 130, def: 80, spa: 65, spd: 85, spe: 55 },
  'Victreebel':   { hp: 80, atk: 105, def: 65, spa: 100, spd: 70, spe: 70 },
  'Slowbro':      { hp: 95, atk: 75, def: 110, spa: 100, spd: 80, spe: 30 },
  'Gengar':       { hp: 60, atk: 65, def: 60, spa: 130, spd: 75, spe: 110 },
  'Kangaskhan':   { hp: 105, atk: 95, def: 80, spa: 40, spd: 80, spe: 90 },
  'Starmie':      { hp: 60, atk: 75, def: 85, spa: 100, spd: 85, spe: 115 },
  'Pinsir':       { hp: 65, atk: 125, def: 100, spa: 55, spd: 70, spe: 85 },
  'Gyarados':     { hp: 95, atk: 125, def: 79, spa: 60, spd: 100, spe: 81 },
  'Snorlax':      { hp: 160, atk: 110, def: 65, spa: 65, spd: 110, spe: 30 },
  'Dragonite':    { hp: 91, atk: 134, def: 95, spa: 100, spd: 100, spe: 80 },
  'Meganium':     { hp: 80, atk: 82, def: 100, spa: 83, spd: 100, spe: 80 },
  'Typhlosion':   { hp: 78, atk: 84, def: 78, spa: 109, spd: 85, spe: 100 },
  'Feraligatr':   { hp: 85, atk: 105, def: 100, spa: 79, spd: 83, spe: 78 },
  'Ampharos':     { hp: 90, atk: 75, def: 85, spa: 115, spd: 90, spe: 55 },
  'Azumarill':    { hp: 100, atk: 50, def: 80, spa: 60, spd: 80, spe: 50 },
  'Politoed':     { hp: 90, atk: 75, def: 75, spa: 90, spd: 100, spe: 70 },
  'Espeon':       { hp: 65, atk: 65, def: 60, spa: 130, spd: 95, spe: 110 },
  'Umbreon':      { hp: 95, atk: 65, def: 110, spa: 60, spd: 130, spe: 65 },
  'Scizor':       { hp: 70, atk: 130, def: 100, spa: 55, spd: 80, spe: 65 },
  'Heracross':    { hp: 80, atk: 125, def: 75, spa: 40, spd: 95, spe: 85 },
  'Skarmory':     { hp: 65, atk: 80, def: 140, spa: 40, spd: 70, spe: 70 },
  'Houndoom':     { hp: 75, atk: 90, def: 50, spa: 110, spd: 80, spe: 95 },
  'Tyranitar':    { hp: 100, atk: 134, def: 110, spa: 95, spd: 100, spe: 61 },
  'Pelipper':     { hp: 60, atk: 50, def: 100, spa: 95, spd: 70, spe: 65 },
  'Gardevoir':    { hp: 68, atk: 65, def: 65, spa: 125, spd: 115, spe: 80 },
  'Aggron':       { hp: 70, atk: 110, def: 180, spa: 60, spd: 60, spe: 50 },
  'Medicham':     { hp: 60, atk: 60, def: 75, spa: 60, spd: 75, spe: 80 },
  'Torkoal':      { hp: 70, atk: 85, def: 140, spa: 85, spd: 70, spe: 20 },
  'Altaria':      { hp: 75, atk: 70, def: 90, spa: 70, spd: 105, spe: 80 },
  'Milotic':      { hp: 95, atk: 60, def: 79, spa: 100, spd: 125, spe: 81 },
  'Absol':        { hp: 65, atk: 130, def: 60, spa: 75, spd: 60, spe: 75 },
  'Glalie':       { hp: 80, atk: 80, def: 80, spa: 80, spd: 80, spe: 80 },
  'Torterra':     { hp: 95, atk: 109, def: 105, spa: 75, spd: 85, spe: 56 },
  'Infernape':    { hp: 76, atk: 104, def: 71, spa: 104, spd: 71, spe: 108 },
  'Empoleon':     { hp: 84, atk: 86, def: 88, spa: 111, spd: 101, spe: 60 },
  'Luxray':       { hp: 80, atk: 120, def: 79, spa: 95, spd: 79, spe: 70 },
  'Garchomp':     { hp: 108, atk: 130, def: 95, spa: 80, spd: 85, spe: 102 },
  'Lucario':      { hp: 70, atk: 110, def: 70, spa: 115, spd: 70, spe: 90 },
  'Hippowdon':    { hp: 108, atk: 112, def: 118, spa: 68, spd: 72, spe: 47 },
  'Toxicroak':    { hp: 83, atk: 106, def: 65, spa: 86, spd: 65, spe: 85 },
  'Abomasnow':    { hp: 90, atk: 92, def: 75, spa: 92, spd: 85, spe: 60 },
  'Weavile':      { hp: 70, atk: 120, def: 65, spa: 45, spd: 85, spe: 125 },
  'Rhyperior':    { hp: 115, atk: 140, def: 130, spa: 55, spd: 55, spe: 40 },
  'Gallade':      { hp: 68, atk: 125, def: 65, spa: 65, spd: 115, spe: 80 },
  'Froslass':     { hp: 70, atk: 80, def: 70, spa: 80, spd: 70, spe: 110 },
  'Rotom':        { hp: 50, atk: 50, def: 77, spa: 95, spd: 77, spe: 91 },
  'Rotom-Heat':   { hp: 50, atk: 65, def: 107, spa: 105, spd: 107, spe: 86 },
  'Rotom-Wash':   { hp: 50, atk: 65, def: 107, spa: 105, spd: 107, spe: 86 },
  'Rotom-Frost':  { hp: 50, atk: 65, def: 107, spa: 105, spd: 107, spe: 86 },
  'Rotom-Fan':    { hp: 50, atk: 65, def: 107, spa: 105, spd: 107, spe: 86 },
  'Rotom-Mow':    { hp: 50, atk: 65, def: 107, spa: 105, spd: 107, spe: 86 },
  'Excadrill':    { hp: 110, atk: 135, def: 60, spa: 50, spd: 65, spe: 88 },
  'Conkeldurr':   { hp: 105, atk: 140, def: 95, spa: 55, spd: 65, spe: 45 },
  'Whimsicott':   { hp: 60, atk: 67, def: 85, spa: 77, spd: 75, spe: 116 },
  'Krookodile':   { hp: 95, atk: 117, def: 80, spa: 65, spd: 70, spe: 92 },
  'Chandelure':   { hp: 60, atk: 55, def: 90, spa: 145, spd: 90, spe: 80 },
  'Hydreigon':    { hp: 92, atk: 105, def: 90, spa: 125, spd: 90, spe: 98 },
  'Volcarona':    { hp: 85, atk: 60, def: 65, spa: 135, spd: 105, spe: 100 },
  'Chesnaught':   { hp: 88, atk: 107, def: 122, spa: 74, spd: 75, spe: 64 },
  'Delphox':      { hp: 75, atk: 69, def: 72, spa: 114, spd: 100, spe: 104 },
  'Greninja':     { hp: 72, atk: 95, def: 67, spa: 103, spd: 71, spe: 122 },
  'Talonflame':   { hp: 78, atk: 81, def: 71, spa: 74, spd: 69, spe: 126 },
  'Aegislash':    { hp: 60, atk: 50, def: 140, spa: 50, spd: 140, spe: 60 },
  'Sylveon':      { hp: 95, atk: 65, def: 65, spa: 110, spd: 130, spe: 60 },
  'Hawlucha':     { hp: 78, atk: 92, def: 75, spa: 74, spd: 63, spe: 118 },
  'Goodra':       { hp: 90, atk: 100, def: 70, spa: 110, spd: 150, spe: 80 },
  'Noivern':      { hp: 85, atk: 70, def: 80, spa: 97, spd: 80, spe: 123 },
  'Decidueye':    { hp: 78, atk: 107, def: 75, spa: 100, spd: 100, spe: 70 },
  'Incineroar':   { hp: 95, atk: 115, def: 90, spa: 80, spd: 90, spe: 60 },
  'Primarina':    { hp: 80, atk: 74, def: 74, spa: 126, spd: 116, spe: 60 },
  'Crabominable': { hp: 97, atk: 132, def: 77, spa: 62, spd: 67, spe: 43 },
  'Toxapex':      { hp: 50, atk: 63, def: 152, spa: 53, spd: 142, spe: 35 },
  'Tsareena':     { hp: 72, atk: 120, def: 98, spa: 50, spd: 98, spe: 72 },
  'Mimikyu':      { hp: 55, atk: 90, def: 80, spa: 50, spd: 105, spe: 96 },
  'Kommo-o':      { hp: 75, atk: 110, def: 125, spa: 100, spd: 105, spe: 85 },
  'Corviknight':  { hp: 98, atk: 87, def: 105, spa: 53, spd: 85, spe: 67 },
  'Hatterene':    { hp: 57, atk: 90, def: 95, spa: 136, spd: 103, spe: 29 },
  'Dragapult':    { hp: 88, atk: 120, def: 75, spa: 100, spd: 75, spe: 142 },
  'Sneasler':     { hp: 80, atk: 130, def: 60, spa: 40, spd: 80, spe: 120 },
  'Basculegion':  { hp: 120, atk: 112, def: 65, spa: 80, spd: 75, spe: 78 },
  'Meowscarada':  { hp: 76, atk: 110, def: 70, spa: 81, spd: 70, spe: 123 },
  'Skeledirge':   { hp: 104, atk: 75, def: 100, spa: 110, spd: 75, spe: 66 },
  'Garganacl':    { hp: 100, atk: 100, def: 130, spa: 45, spd: 90, spe: 35 },
  'Armarouge':    { hp: 85, atk: 60, def: 100, spa: 125, spd: 80, spe: 75 },
  'Ceruledge':    { hp: 75, atk: 125, def: 80, spa: 60, spd: 100, spe: 85 },
  'Tinkaton':     { hp: 85, atk: 75, def: 77, spa: 70, spd: 105, spe: 94 },
  'Palafin':      { hp: 100, atk: 70, def: 72, spa: 53, spd: 62, spe: 100 },
  'Glimmora':     { hp: 83, atk: 55, def: 90, spa: 130, spd: 81, spe: 86 },
  'Farigiraf':    { hp: 120, atk: 90, def: 70, spa: 110, spd: 70, spe: 60 },
  'Kingambit':    { hp: 100, atk: 135, def: 120, spa: 60, spd: 85, spe: 50 },
  'Sinistcha':    { hp: 71, atk: 60, def: 106, spa: 121, spd: 80, spe: 70 },
  'Archaludon':   { hp: 90, atk: 105, def: 130, spa: 125, spd: 65, spe: 85 },
  'Lopunny':      { hp: 65, atk: 76, def: 84, spa: 54, spd: 96, spe: 105 },
  'Mamoswine':    { hp: 110, atk: 130, def: 80, spa: 70, spd: 60, spe: 80 },
  'Gliscor':      { hp: 75, atk: 95, def: 125, spa: 45, spd: 75, spe: 95 },
  'Maushold':     { hp: 74, atk: 75, def: 70, spa: 65, spd: 75, spe: 111 },
  'Oranguru':     { hp: 90, atk: 60, def: 80, spa: 90, spd: 110, spe: 60 },
  // Remaining Champions roster
  'Raichu-Alola': { hp: 60, atk: 85, def: 50, spa: 95, spd: 85, spe: 110 },
  'Arcanine-Hisui': { hp: 95, atk: 115, def: 80, spa: 95, spd: 80, spe: 90 },
  'Slowbro-Galarian': { hp: 95, atk: 100, def: 95, spa: 100, spd: 70, spe: 30 },
  'Tauros':       { hp: 75, atk: 100, def: 95, spa: 40, spd: 70, spe: 110 },
  'Tauros-Paldea': { hp: 75, atk: 110, def: 105, spa: 30, spd: 70, spe: 100 },
  'Ditto':        { hp: 48, atk: 48, def: 48, spa: 48, spd: 48, spe: 48 },
  'Vaporeon':     { hp: 130, atk: 65, def: 60, spa: 110, spd: 95, spe: 65 },
  'Jolteon':      { hp: 65, atk: 65, def: 60, spa: 110, spd: 95, spe: 130 },
  'Flareon':      { hp: 65, atk: 130, def: 60, spa: 95, spd: 110, spe: 65 },
  'Aerodactyl':   { hp: 80, atk: 105, def: 65, spa: 60, spd: 75, spe: 130 },
  'Typhlosion-Hisui': { hp: 73, atk: 84, def: 78, spa: 119, spd: 85, spe: 95 },
  'Ariados':      { hp: 70, atk: 90, def: 70, spa: 60, spd: 70, spe: 40 },
  'Slowking':     { hp: 95, atk: 75, def: 80, spa: 100, spd: 110, spe: 30 },
  'Slowking-Galarian': { hp: 95, atk: 65, def: 80, spa: 110, spd: 110, spe: 30 },
  'Forretress':   { hp: 75, atk: 90, def: 140, spa: 60, spd: 60, spe: 40 },
  'Steelix':      { hp: 75, atk: 85, def: 200, spa: 55, spd: 65, spe: 30 },
  'Sableye':      { hp: 50, atk: 75, def: 75, spa: 65, spd: 65, spe: 50 },
  'Electrike':    { hp: 40, atk: 45, def: 40, spa: 65, spd: 40, spe: 65 },
  'Manectric':    { hp: 70, atk: 75, def: 60, spa: 105, spd: 60, spe: 105 },
  'Sharpedo':     { hp: 70, atk: 120, def: 40, spa: 95, spd: 40, spe: 95 },
  'Camerupt':     { hp: 70, atk: 100, def: 70, spa: 105, spd: 75, spe: 40 },
  'Castform':     { hp: 70, atk: 70, def: 70, spa: 70, spd: 70, spe: 70 },
  'Banette':      { hp: 64, atk: 115, def: 65, spa: 83, spd: 63, spe: 65 },
  'Chimecho':     { hp: 75, atk: 50, def: 80, spa: 95, spd: 90, spe: 65 },
  'Roserade':     { hp: 60, atk: 70, def: 65, spa: 125, spd: 105, spe: 90 },
  'Rampardos':    { hp: 97, atk: 165, def: 60, spa: 65, spd: 50, spe: 58 },
  'Bastiodon':    { hp: 60, atk: 52, def: 168, spa: 47, spd: 138, spe: 30 },
  'Spiritomb':    { hp: 50, atk: 92, def: 108, spa: 92, spd: 108, spe: 35 },
  'Leafeon':      { hp: 65, atk: 110, def: 130, spa: 60, spd: 65, spe: 95 },
  'Glaceon':      { hp: 65, atk: 60, def: 110, spa: 130, spd: 95, spe: 65 },
  'Serperior':    { hp: 75, atk: 75, def: 95, spa: 75, spd: 95, spe: 113 },
  'Emboar':       { hp: 110, atk: 123, def: 65, spa: 100, spd: 65, spe: 65 },
  'Samurott':     { hp: 95, atk: 100, def: 85, spa: 108, spd: 70, spe: 70 },
  'Samurott-Hisui': { hp: 90, atk: 108, def: 80, spa: 100, spd: 65, spe: 85 },
  'Watchog':      { hp: 60, atk: 85, def: 69, spa: 60, spd: 69, spe: 77 },
  'Liepard':      { hp: 64, atk: 88, def: 50, spa: 88, spd: 50, spe: 106 },
  'Simisage':     { hp: 75, atk: 98, def: 63, spa: 98, spd: 63, spe: 101 },
  'Simisear':     { hp: 75, atk: 98, def: 63, spa: 98, spd: 63, spe: 101 },
  'Simipour':     { hp: 75, atk: 98, def: 63, spa: 98, spd: 63, spe: 101 },
  'Audino':       { hp: 103, atk: 60, def: 86, spa: 60, spd: 86, spe: 50 },
  'Cofagrigus':   { hp: 58, atk: 50, def: 145, spa: 95, spd: 105, spe: 30 },
  'Garbodor':     { hp: 80, atk: 95, def: 82, spa: 60, spd: 82, spe: 75 },
  'Zoroark':      { hp: 60, atk: 105, def: 60, spa: 120, spd: 60, spe: 105 },
  'Zoroark-Hisui':{ hp: 55, atk: 100, def: 60, spa: 125, spd: 60, spe: 110 },
  'Reuniclus':    { hp: 110, atk: 65, def: 75, spa: 125, spd: 85, spe: 30 },
  'Vanilluxe':    { hp: 71, atk: 95, def: 85, spa: 110, spd: 95, spe: 79 },
  'Emolga':       { hp: 55, atk: 75, def: 60, spa: 75, spd: 60, spe: 103 },
  'Beartic':      { hp: 95, atk: 130, def: 80, spa: 70, spd: 80, spe: 50 },
  'Stunfisk':     { hp: 109, atk: 66, def: 84, spa: 81, spd: 99, spe: 32 },
  'Stunfisk-Galarian': { hp: 109, atk: 81, def: 99, spa: 66, spd: 84, spe: 32 },
  'Golurk':       { hp: 89, atk: 124, def: 80, spa: 55, spd: 80, spe: 55 },
  'Diggersby':    { hp: 85, atk: 56, def: 77, spa: 50, spd: 77, spe: 78 },
  'Vivillon':     { hp: 80, atk: 52, def: 50, spa: 90, spd: 50, spe: 89 },
  'Floette':      { hp: 54, atk: 45, def: 47, spa: 75, spd: 98, spe: 52 },
  'Florges':      { hp: 78, atk: 65, def: 68, spa: 112, spd: 154, spe: 75 },
  'Pangoro':      { hp: 95, atk: 124, def: 78, spa: 69, spd: 71, spe: 58 },
  'Furfrou':      { hp: 75, atk: 80, def: 60, spa: 65, spd: 90, spe: 102 },
  'Meowstic':     { hp: 74, atk: 48, def: 76, spa: 83, spd: 81, spe: 104 },
  'Aromatisse':   { hp: 101, atk: 72, def: 72, spa: 99, spd: 89, spe: 29 },
  'Slurpuff':     { hp: 82, atk: 80, def: 86, spa: 85, spd: 75, spe: 72 },
  'Clawitzer':    { hp: 71, atk: 73, def: 88, spa: 120, spd: 89, spe: 59 },
  'Heliolisk':    { hp: 62, atk: 55, def: 52, spa: 109, spd: 94, spe: 109 },
  'Tyrantrum':    { hp: 82, atk: 121, def: 119, spa: 69, spd: 59, spe: 71 },
  'Aurorus':      { hp: 123, atk: 77, def: 72, spa: 99, spd: 92, spe: 58 },
  'Dedenne':      { hp: 67, atk: 58, def: 57, spa: 81, spd: 67, spe: 101 },
  'Goodra-Hisui': { hp: 80, atk: 100, def: 100, spa: 110, spd: 150, spe: 60 },
  'Klefki':       { hp: 57, atk: 80, def: 91, spa: 80, spd: 87, spe: 75 },
  'Trevenant':    { hp: 85, atk: 110, def: 76, spa: 65, spd: 82, spe: 56 },
  'Gourgeist':    { hp: 65, atk: 90, def: 122, spa: 58, spd: 75, spe: 84 },
  'Avalugg':      { hp: 95, atk: 117, def: 184, spa: 44, spd: 46, spe: 28 },
  'Avalugg-Hisui':{ hp: 95, atk: 127, def: 184, spa: 34, spd: 36, spe: 38 },
  'Decidueye-Hisui': { hp: 88, atk: 112, def: 80, spa: 95, spd: 95, spe: 60 },
  'Toucannon':    { hp: 80, atk: 120, def: 75, spa: 75, spd: 75, spe: 60 },
  'Lycanroc':     { hp: 75, atk: 115, def: 65, spa: 55, spd: 65, spe: 112 },
  'Mudsdale':     { hp: 100, atk: 125, def: 100, spa: 55, spd: 85, spe: 35 },
  'Araquanid':    { hp: 68, atk: 70, def: 92, spa: 50, spd: 132, spe: 42 },
  'Salazzle':     { hp: 68, atk: 64, def: 60, spa: 111, spd: 60, spe: 117 },
  'Passimian':    { hp: 100, atk: 120, def: 90, spa: 40, spd: 60, spe: 80 },
  'Drampa':       { hp: 78, atk: 60, def: 85, spa: 135, spd: 91, spe: 36 },
  'Flapple':      { hp: 70, atk: 110, def: 80, spa: 95, spd: 60, spe: 70 },
  'Appletun':     { hp: 110, atk: 85, def: 80, spa: 100, spd: 80, spe: 30 },
  'Sandaconda':   { hp: 72, atk: 107, def: 125, spa: 65, spd: 70, spe: 71 },
  'Polteageist':  { hp: 60, atk: 65, def: 65, spa: 134, spd: 114, spe: 70 },
  'Mr. Rime':     { hp: 80, atk: 85, def: 75, spa: 110, spd: 100, spe: 70 },
  'Runerigus':    { hp: 58, atk: 95, def: 145, spa: 50, spd: 105, spe: 30 },
  'Alcremie':     { hp: 65, atk: 60, def: 75, spa: 110, spd: 121, spe: 64 },
  'Morpeko':      { hp: 58, atk: 95, def: 58, spa: 70, spd: 58, spe: 97 },
  'Wyrdeer':      { hp: 103, atk: 105, def: 72, spa: 105, spd: 75, spe: 65 },
  'Kleavor':      { hp: 70, atk: 135, def: 95, spa: 45, spd: 70, spe: 85 },
  'Quaquaval':    { hp: 85, atk: 120, def: 80, spa: 85, spd: 75, spe: 85 },
  'Bellibolt':    { hp: 109, atk: 64, def: 91, spa: 103, spd: 83, spe: 45 },
  'Scovillain':   { hp: 65, atk: 108, def: 65, spa: 108, spd: 65, spe: 75 },
  'Espathra':     { hp: 95, atk: 60, def: 60, spa: 101, spd: 80, spe: 105 },
  'Orthworm':     { hp: 70, atk: 85, def: 145, spa: 60, spd: 55, spe: 65 },
  'Hydrapple':    { hp: 106, atk: 80, def: 110, spa: 120, spd: 80, spe: 44 },
};

// Mega stat overrides
// All Mega Evolution stats for Pokemon Champions
// Source: Serebii Pokemon Champions + game data
const MEGA_STATS = {
  // Gen 1 Megas
  'Venusaur':     { hp: 80, atk: 100, def: 123, spa: 122, spd: 120, spe: 80 },
  'Charizard':    { hp: 78, atk: 130, def: 111, spa: 130, spd: 85, spe: 100 }, // X stats (default)
  'Charizard-Y':  { hp: 78, atk: 104, def: 78, spa: 159, spd: 115, spe: 100 }, // Y stats
  'Blastoise':    { hp: 79, atk: 103, def: 120, spa: 135, spd: 115, spe: 78 },
  'Beedrill':     { hp: 65, atk: 150, def: 40, spa: 15, spd: 80, spe: 145 },
  'Pidgeot':      { hp: 83, atk: 80, def: 80, spa: 135, spd: 80, spe: 121 },
  'Alakazam':     { hp: 55, atk: 50, def: 65, spa: 175, spd: 105, spe: 150 },
  'Slowbro':      { hp: 95, atk: 75, def: 180, spa: 130, spd: 80, spe: 30 },
  'Gengar':       { hp: 60, atk: 65, def: 80, spa: 170, spd: 95, spe: 130 },
  'Kangaskhan':   { hp: 105, atk: 125, def: 100, spa: 60, spd: 100, spe: 100 },
  'Pinsir':       { hp: 65, atk: 155, def: 120, spa: 65, spd: 90, spe: 105 },
  'Gyarados':     { hp: 95, atk: 155, def: 109, spa: 70, spd: 130, spe: 81 },
  'Aerodactyl':   { hp: 80, atk: 135, def: 85, spa: 70, spd: 95, spe: 150 },
  'Dragonite':    { hp: 91, atk: 124, def: 115, spa: 145, spd: 125, spe: 100 },
  // Starmie & Clefable & Victreebel (new Champions megas)
  'Starmie':      { hp: 60, atk: 75, def: 105, spa: 140, spd: 105, spe: 135 },
  'Clefable':     { hp: 95, atk: 70, def: 93, spa: 135, spd: 110, spe: 60 },
  'Victreebel':   { hp: 80, atk: 135, def: 75, spa: 130, spd: 80, spe: 80 },
  // Gen 2 Megas
  'Meganium':     { hp: 80, atk: 82, def: 120, spa: 123, spd: 120, spe: 80 },
  'Feraligatr':   { hp: 85, atk: 135, def: 120, spa: 99, spd: 103, spe: 98 },
  'Ampharos':     { hp: 90, atk: 95, def: 105, spa: 165, spd: 110, spe: 45 },
  'Scizor':       { hp: 70, atk: 150, def: 140, spa: 65, spd: 100, spe: 75 },
  'Heracross':    { hp: 80, atk: 185, def: 115, spa: 40, spd: 105, spe: 75 },
  'Houndoom':     { hp: 75, atk: 90, def: 90, spa: 140, spd: 90, spe: 115 },
  'Tyranitar':    { hp: 100, atk: 164, def: 150, spa: 95, spd: 120, spe: 71 },
  'Skarmory':     { hp: 65, atk: 100, def: 160, spa: 40, spd: 90, spe: 90 },
  'Steelix':      { hp: 75, atk: 125, def: 230, spa: 55, spd: 95, spe: 30 },
  // Gen 3 Megas
  'Sableye':      { hp: 50, atk: 85, def: 125, spa: 85, spd: 115, spe: 20 },
  'Aggron':       { hp: 70, atk: 140, def: 230, spa: 60, spd: 80, spe: 50 },
  'Medicham':     { hp: 60, atk: 100, def: 85, spa: 80, spd: 85, spe: 100 },
  'Manectric':    { hp: 70, atk: 75, def: 80, spa: 135, spd: 80, spe: 135 },
  'Sharpedo':     { hp: 70, atk: 140, def: 70, spa: 110, spd: 65, spe: 105 },
  'Camerupt':     { hp: 70, atk: 120, def: 100, spa: 145, spd: 105, spe: 20 },
  'Altaria':      { hp: 75, atk: 110, def: 110, spa: 110, spd: 105, spe: 80 },
  'Banette':      { hp: 64, atk: 165, def: 75, spa: 93, spd: 83, spe: 75 },
  'Absol':        { hp: 65, atk: 150, def: 60, spa: 115, spd: 60, spe: 115 },
  'Glalie':       { hp: 80, atk: 120, def: 80, spa: 120, spd: 80, spe: 100 },
  'Gardevoir':    { hp: 68, atk: 85, def: 65, spa: 165, spd: 135, spe: 100 },
  // Gen 3 new Champions megas
  'Chimecho':     { hp: 75, atk: 50, def: 100, spa: 135, spd: 110, spe: 85 },
  // Gen 4 Megas
  'Lopunny':      { hp: 65, atk: 136, def: 94, spa: 54, spd: 96, spe: 135 },
  'Lucario':      { hp: 70, atk: 145, def: 88, spa: 140, spd: 70, spe: 112 },
  'Garchomp':     { hp: 108, atk: 170, def: 115, spa: 120, spd: 95, spe: 92 },
  'Abomasnow':    { hp: 90, atk: 132, def: 105, spa: 132, spd: 105, spe: 30 },
  'Gallade':      { hp: 68, atk: 165, def: 95, spa: 65, spd: 115, spe: 110 },
  'Froslass':     { hp: 70, atk: 80, def: 80, spa: 140, spd: 90, spe: 120 },
  // Gen 5 Megas (new Champions)
  'Emboar':       { hp: 110, atk: 153, def: 85, spa: 120, spd: 85, spe: 75 },
  'Excadrill':    { hp: 110, atk: 165, def: 80, spa: 50, spd: 85, spe: 108 },
  'Audino':       { hp: 103, atk: 60, def: 126, spa: 80, spd: 126, spe: 50 },
  'Chandelure':   { hp: 60, atk: 55, def: 110, spa: 175, spd: 110, spe: 80 },
  'Golurk':       { hp: 89, atk: 154, def: 100, spa: 55, spd: 100, spe: 55 },
  'Volcarona':    { hp: 85, atk: 60, def: 85, spa: 165, spd: 125, spe: 100 },
  // Gen 6 Megas (new Champions)
  'Chesnaught':   { hp: 88, atk: 137, def: 142, spa: 74, spd: 95, spe: 64 },
  'Delphox':      { hp: 75, atk: 69, def: 82, spa: 154, spd: 110, spe: 114 },
  'Greninja':     { hp: 72, atk: 115, def: 77, spa: 133, spd: 81, spe: 132 },
  'Meowstic':     { hp: 74, atk: 48, def: 96, spa: 123, spd: 101, spe: 124 },
  'Hawlucha':     { hp: 78, atk: 112, def: 85, spa: 94, spd: 73, spe: 138 },
  // Gen 6 existing megas
  'Floette':      { hp: 54, atk: 45, def: 67, spa: 125, spd: 128, spe: 72 },
  // Gen 7 Megas (new Champions)
  'Crabominable': { hp: 97, atk: 152, def: 97, spa: 62, spd: 87, spe: 63 },
  'Drampa':       { hp: 78, atk: 60, def: 105, spa: 165, spd: 111, spe: 36 },
  // Gen 8 (new Champions)
  'Scovillain':   { hp: 65, atk: 138, def: 75, spa: 138, spd: 75, spe: 85 },
  // Gen 9 (new Champions)
  'Glimmora':     { hp: 83, atk: 55, def: 110, spa: 160, spd: 101, spe: 96 },
};

// Mega stone -> Pokemon name mapping (all Champions megas)
const MEGA_STONE_MAP = {
  // Gen 1
  'Venusaurite': 'Venusaur', 'Charizardite X': 'Charizard', 'Charizardite Y': 'Charizard',
  'Blastoisinite': 'Blastoise', 'Beedrillite': 'Beedrill', 'Pidgeotite': 'Pidgeot',
  'Alakazite': 'Alakazam', 'Slowbronite': 'Slowbro', 'Gengarite': 'Gengar',
  'Kangaskhanite': 'Kangaskhan', 'Pinsirite': 'Pinsir', 'Gyaradosite': 'Gyarados',
  'Aerodactylite': 'Aerodactyl', 'Dragonitite': 'Dragonite',
  'Starmieite': 'Starmie', 'Clefablite': 'Clefable', 'Victreebelite': 'Victreebel',
  // Gen 2
  'Meganiumite': 'Meganium', 'Feraligatrite': 'Feraligatr', 'Ampharosite': 'Ampharos',
  'Scizorite': 'Scizor', 'Heracronite': 'Heracross', 'Houndoominite': 'Houndoom',
  'Tyranitarite': 'Tyranitar', 'Skarmoryite': 'Skarmory', 'Steelixite': 'Steelix',
  // Gen 3
  'Sablenite': 'Sableye', 'Aggronite': 'Aggron', 'Medichamite': 'Medicham',
  'Manectite': 'Manectric', 'Sharpedonite': 'Sharpedo', 'Cameruptite': 'Camerupt',
  'Altarianite': 'Altaria', 'Banettite': 'Banette', 'Absolite': 'Absol',
  'Glalitite': 'Glalie', 'Gardevoirite': 'Gardevoir', 'Chimechite': 'Chimecho',
  // Gen 4
  'Lopunnite': 'Lopunny', 'Lucarionite': 'Lucario', 'Garchompite': 'Garchomp',
  'Abomasite': 'Abomasnow', 'Galladite': 'Gallade', 'Frosslasite': 'Froslass',
  // Gen 5
  'Emboarite': 'Emboar', 'Excadrilite': 'Excadrill', 'Audinite': 'Audino',
  'Chandelurite': 'Chandelure', 'Golurkite': 'Golurk',
  // Gen 6
  'Chesnaughtite': 'Chesnaught', 'Delphoxite': 'Delphox', 'Greninjaite': 'Greninja',
  'Meowstite': 'Meowstic', 'Hawluchite': 'Hawlucha', 'Floettite': 'Floette',
  // Gen 7
  'Crabominite': 'Crabominable', 'Drampite': 'Drampa',
  // Gen 8-9
  'Scovillainite': 'Scovillain', 'Glimmorite': 'Glimmora',
};

// Mega type changes — only Pokemon whose type changes on Mega Evolution
const MEGA_TYPE_OVERRIDES = {
  'Charizard':  { 'Charizardite X': ['Fire', 'Dragon'], 'Charizardite Y': ['Fire', 'Flying'] },
  'Gyarados':   { 'Gyaradosite': ['Water', 'Dark'] },
  'Ampharos':   { 'Ampharosite': ['Electric', 'Dragon'] },
  'Altaria':    { 'Altarianite': ['Dragon', 'Fairy'] },
  'Lopunny':    { 'Lopunnite': ['Normal', 'Fighting'] },
  'Audino':     { 'Audinite': ['Normal', 'Fairy'] },
  'Pinsir':     { 'Pinsirite': ['Bug', 'Flying'] },
  'Aggron':     { 'Aggronite': ['Steel'] },
  // New Champions megas with type changes
  'Feraligatr': { 'Feraligatrite': ['Water', 'Dragon'] },
  'Clefable':   { 'Clefablite': ['Fairy'] }, // stays Fairy (was already Fairy in base, included for completeness)
  'Scovillain':  { 'Scovillainite': ['Grass', 'Fire'] }, // same types
};

/**
 * Get the types a Pokemon has when Mega Evolved.
 * Returns null if no type change occurs.
 * If itemName is provided, uses that for Charizard X/Y distinction.
 * Otherwise returns the first available override.
 */
export function getMegaTypes(pokemonName, itemName) {
  const overrides = MEGA_TYPE_OVERRIDES[pokemonName];
  if (!overrides) return null;
  if (itemName && overrides[itemName]) return overrides[itemName];
  // Fallback: return first available override
  const vals = Object.values(overrides);
  return vals.length > 0 ? vals[0] : null;
}

/**
 * Check if a Pokemon has a Mega Evolution available (in the MEGA_STATS database).
 */
export function canMegaEvolve(pokemon) {
  return pokemon.name in MEGA_STATS;
}

export function getBaseStats(pokemonName) {
  return BASE_STATS[pokemonName] || null;
}

export function getMegaStats(pokemonName) {
  return MEGA_STATS[pokemonName] || null;
}

export function isMegaStone(itemName) {
  return itemName in MEGA_STONE_MAP;
}

export function getMegaStoneTarget(itemName) {
  return MEGA_STONE_MAP[itemName] || null;
}

// Mega abilities — keyed by Pokemon name, or by stone name for dual megas
const MEGA_ABILITIES = {
  'Venusaur': 'Thick Fat', 'Charizardite X': 'Tough Claws', 'Charizardite Y': 'Drought',
  'Blastoise': 'Mega Launcher', 'Beedrill': 'Adaptability', 'Pidgeot': 'No Guard',
  'Alakazam': 'Trace', 'Slowbro': 'Shell Armor', 'Gengar': 'Shadow Tag',
  'Kangaskhan': 'Parental Bond', 'Pinsir': 'Aerilate', 'Gyarados': 'Mold Breaker',
  'Aerodactyl': 'Tough Claws', 'Dragonite': 'Multiscale',
  'Starmie': 'Analytic', 'Clefable': 'Unaware', 'Victreebel': 'Chlorophyll',
  'Meganium': 'Mega Sol', 'Feraligatr': 'Tough Claws', 'Ampharos': 'Mold Breaker',
  'Scizor': 'Technician', 'Heracross': 'Skill Link', 'Houndoom': 'Solar Power',
  'Tyranitar': 'Sand Stream', 'Skarmory': 'Mirror Armor', 'Steelix': 'Sand Force',
  'Sableye': 'Magic Bounce', 'Aggron': 'Filter', 'Medicham': 'Pure Power',
  'Manectric': 'Intimidate', 'Sharpedo': 'Strong Jaw', 'Camerupt': 'Sheer Force',
  'Altaria': 'Pixilate', 'Banette': 'Prankster', 'Absol': 'Magic Bounce',
  'Glalie': 'Refrigerate', 'Gardevoir': 'Pixilate', 'Chimecho': 'Levitate',
  'Lopunny': 'Scrappy', 'Lucario': 'Adaptability', 'Garchomp': 'Sand Force',
  'Abomasnow': 'Snow Warning', 'Gallade': 'Inner Focus', 'Froslass': 'Snow Warning',
  'Emboar': 'Reckless', 'Excadrill': 'Mold Breaker', 'Audino': 'Healer',
  'Chandelure': 'Shadow Tag', 'Golurk': 'Iron Fist', 'Volcarona': 'Swarm',
  'Chesnaught': 'Bulletproof', 'Delphox': 'Magician', 'Greninja': 'Protean',
  'Meowstic': 'Prankster', 'Hawlucha': 'Mold Breaker', 'Floette': 'Fairy Aura',
  'Crabominable': 'Iron Fist', 'Drampa': 'Cloud Nine',
  'Scovillain': 'Drought', 'Glimmora': 'Corrosion',
};

/**
 * Get the ability a Pokemon has when Mega Evolved.
 * For dual megas (Charizard), pass the stone name.
 */
export function getMegaAbility(pokemonName, stoneName) {
  // Check stone-specific ability first (Charizard X vs Y)
  if (stoneName && MEGA_ABILITIES[stoneName]) return MEGA_ABILITIES[stoneName];
  return MEGA_ABILITIES[pokemonName] || null;
}

/**
 * Get mega stats for a specific mega stone (handles Charizard X vs Y).
 */
export function getMegaStatsByStone(pokemonName, stoneName) {
  // Special case: Charizard Y has separate stats
  if (pokemonName === 'Charizard' && stoneName === 'Charizardite Y') {
    return MEGA_STATS['Charizard-Y'] || MEGA_STATS['Charizard'];
  }
  return MEGA_STATS[pokemonName] || null;
}

/**
 * Get all mega stone options for a Pokemon.
 * Returns array of { stone, label } for Pokemon with megas.
 */
export function getMegaStones(pokemonName) {
  const stones = [];
  for (const [stone, target] of Object.entries(MEGA_STONE_MAP)) {
    if (target === pokemonName) {
      stones.push({ stone, label: stone.replace('ite', '').replace(pokemonName, '').trim() || 'Mega' });
    }
  }
  return stones;
}

export const ALL_ITEMS = [
  // Mega Stones
  ...Object.keys(MEGA_STONE_MAP),
  // Competitive items
  'Black Belt', 'Black Glasses', 'Bright Powder', 'Charcoal', 'Choice Scarf',
  'Dragon Fang', 'Fairy Feather', 'Focus Band', 'Focus Sash', 'Hard Stone',
  "King's Rock", 'Leftovers', 'Light Ball', 'Magnet', 'Mental Herb',
  'Metal Coat', 'Miracle Seed', 'Mystic Water', 'Never-Melt Ice', 'Poison Barb',
  'Quick Claw', 'Scope Lens', 'Sharp Beak', 'Shell Bell', 'Silk Scarf',
  'Silver Powder', 'Soft Sand', 'Spell Tag', 'Twisted Spoon', 'White Herb',
  'Sitrus Berry', 'Lum Berry',
  // Type-resist berries
  'Occa Berry', 'Passho Berry', 'Wacan Berry', 'Rindo Berry', 'Yache Berry',
  'Chople Berry', 'Kebia Berry', 'Shuca Berry', 'Coba Berry', 'Payapa Berry',
  'Tanga Berry', 'Charti Berry', 'Kasib Berry', 'Haban Berry', 'Colbur Berry',
  'Babiri Berry', 'Roseli Berry',
].sort();

export { BASE_STATS, MEGA_STATS, MEGA_STONE_MAP };
